import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { TRButton } from "@/components/TRButton";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(email, password);
            toast.success("Welcome back.");
            navigate(u.role === "admin" ? "/admin" : "/account");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Login failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="login-page" className="pt-32 md:pt-44 min-h-[80vh]">
            <div className="max-w-[440px] mx-auto px-5 sm:px-8">
                <span className="eyebrow text-ink/50">Account</span>
                <h1 className="mt-4 font-serif font-light text-5xl tracking-[-0.04em]">
                    Sign in
                </h1>
                <form onSubmit={submit} className="mt-12 space-y-6">
                    <Field
                        label="Email"
                        type="email"
                        value={email}
                        onChange={setEmail}
                        testid="login-email"
                    />
                    <Field
                        label="Password"
                        type="password"
                        value={password}
                        onChange={setPassword}
                        testid="login-password"
                    />
                    <TRButton full type="submit" disabled={loading} data-testid="login-submit">
                        {loading ? "Signing in…" : "Sign In"}
                    </TRButton>
                </form>
                <p className="mt-8 text-sm text-ink/60">
                    No account?{" "}
                    <Link to="/register" className="text-ink link-underline" data-testid="to-register">
                        Create one
                    </Link>
                </p>
            </div>
        </div>
    );
}

export const Field = ({ label, type, value, onChange, testid }) => (
    <label className="block">
        <span className="eyebrow text-ink/50">{label}</span>
        <input
            type={type}
            required
            value={value}
            onChange={(e) => onChange(e.target.value)}
            data-testid={testid}
            className="mt-3 w-full bg-transparent border-b border-line focus:border-ink outline-none py-3 text-lg transition-colors"
        />
    </label>
);
